<template>
  <section>
    <div class="at container">
      <div class="title">车友社区</div>
      <div class="head" v-if="headImg">
        <router-link :to="{name: 'userHome'}">
          <img :src="headImg"/>
        </router-link>
      </div>
      <div class="search_form">
        <input type="text" name="courseName" v-model="tabSearchH" placeholder="请输入关键字">
        <i class="iconfont icon-search" @click="articleQuery()"></i>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    headColor: {
      type: String,
      default: ''
    },
    keyWord: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tabSearchH: '',
      headImg: null,
      defaultHeadImg: require('../../assets/image/installer.png'),
      searchIcon: require('../../assets/icon/search_icom.png')
    }
  },
  methods: {
    articleQuery: function () {
      this.$router.push({
        name: 'articleQuery', query: {keyWord: this.tabSearchH}
      })
      if (this.keyWord !== this.tabSearchH) {
        this.$emit('setWord', this.tabSearchH)
      }
    }
  },
  mounted: function (s) {
    console.log(this.keyWord)
    this.tabSearchH = this.keyWord
    if (this.$root.getUserId()) {
      this.headImg = this.$store.state.user.headImg || this.defaultHeadImg
    }
  },
  computed: {
  },
  watch: {
    'keyWord': function () {
      this.tabSearchH = this.keyWord
    }
  }
}
</script>

<style scoped>
.at {
  padding-top: 22px;
  padding-bottom: 15px;
  width: 1200px;
  border-bottom: 1px solid #E3E3E3;
  margin-bottom: 30px;
}
.at .title{
  font-family: FZYH_510M;
  float: left;
  font-size: 25px;
  color: #191b1b;
  line-height: 40px;
}
.search_form {
  position: relative;
  float: right;
  border: 1px solid #EEEEEE;
  height: 30px;
  width: 300px;
  margin: 5px 0;
}
.icon-search{
  font-size: 20px;
  position: absolute;
  top: 4px;
  right: 20px;
  color: #666;
}
.head {
  float: right;
}
.head img {
  width: 40px;
  height: 40px;
  margin-left: 20px;
  border-radius: 50%;
}
.search_form input{
  float: left;
  width: 293px;
  height: 30px;
  line-height: 25px;
  border-radius: 30px;
  border: 1px solid #666;
  padding-left: 15px;
  box-sizing: border-box;
  background-color: #eeeeee;
  font-family: "SourceHanSansCN-Light";
}
</style>



// WEBPACK FOOTER //
// src/components/common/articleTitle.vue